<template>
  <div>
    <PageHeaderBanner v-if="poType === 'PO_RE_ARIBA'">
      <template #title>チェックアウト済アイテム</template>
    </PageHeaderBanner>
    <PageHeaderBanner v-else-if="poType === 'PO_ARIBA'">
      <template #title>チェックアウト</template>
    </PageHeaderBanner>
    <PageHeaderBanner v-else>
      <template #title>注文/問い合わせ</template>
    </PageHeaderBanner>
    <div class="csr00100-order-form">
      <div
        class="row q-gutter-x-sm items-end q-mb-md"
        style="border-bottom: 1px solid var(--q-whiteBorder); padding: 0 5%; padding-right: 3%"
      >
        <div class="col-3">
          <q-tabs
            v-model="tab"
            dense
            align="justify"
            class="text-grey"
            active-color="primary"
            indicator-color="primary"
            :breakpoint="0"
            @click="checkRegDialog()"
          >
            <q-tab :ripple="false" :name="TYPE.ORDER" label="注文">
              <q-badge
                class="tab-badge"
                color="secondary"
                text-color="dark"
                floating
                rounded
                align="bottom"
              >
                {{ order.length }}
              </q-badge>
            </q-tab>
            <q-tab
              v-if="poType === 'PO_NORMAL'"
              :ripple="false"
              :name="TYPE.QUOTE"
              label="問い合わせ"
            >
              <q-badge
                class="tab-badge"
                color="secondary"
                text-color="dark"
                floating
                rounded
                align="bottom"
              >
                {{ quotable.length }}
              </q-badge>
            </q-tab>
          </q-tabs>
        </div>
        <div class="col flex justify-end q-pb-sm q-gutter-sm">
          <BatchInputBtn
            :capacity-flg="tab === TYPE.QUOTE"
            :disable="
              (tab === TYPE.ORDER && order.length === 0) ||
              (tab === TYPE.QUOTE && quotable.length === 0) ||
              (tab === TYPE.ORDER && poType === 'PO_RE_ARIBA') ||
              cartLimitFlg === true
            "
            @batch-input="allInput($event, tab)"
          />
          <q-btn
            color="primary"
            outline
            icon="mdi-download"
            no-caps
            class="export-btn"
            :disable="
              (tab === TYPE.ORDER && order.length === 0) ||
              (tab === TYPE.QUOTE && quotable.length === 0) ||
              cartLimitFlg === true
            "
            @click="displayOutExcelDialog"
            >Excel出力</q-btn
          >
          <q-btn
            icon="mdi-download"
            color="primary"
            outline
            no-caps
            class="export-btn"
            :disable="
              (tab === TYPE.ORDER && order.length === 0) ||
              (tab === TYPE.QUOTE && quotable.length === 0) ||
              cartLimitFlg === true
            "
            @click="displayOutSdfDialog"
            >SDFile出力</q-btn
          >
          <q-btn
            icon="mdi-trash-can-outline"
            color="grey-7"
            outline
            class="export-btn"
            :disable="
              (tab === TYPE.ORDER && order.length === 0) ||
              (tab === TYPE.QUOTE && quotable.length === 0) ||
              (tab === TYPE.ORDER && poType === 'PO_RE_ARIBA') ||
              cartLimitFlg === true
            "
            @click="allDeleteConfirmDialog"
            >すべて削除</q-btn
          >
        </div>
      </div>
      <div
        class="row justify-between"
        style="width: 95%; margin: 0 auto; margin-left: 5%; position: relative"
      >
        <q-tab-panels v-model="tab" animated style="height: calc(100vh - 220px); width: 100%">
          <q-tab-panel :name="TYPE.ORDER">
            <div
              v-if="
                order.length !== 0 &&
                (poType === 'PO_NORMAL' || poType === 'PO_ARIBA') &&
                cartLimit.length > 0
              "
            >
              <p class="q-mb-none">カートの有効期限は {{ cartLimit }}になります。</p>
            </div>
            <div
              v-if="
                order.length !== 0 &&
                (poType === 'PO_NORMAL' || poType === 'PO_ARIBA') &&
                cartLimitFlg === true
              "
            >
              <p class="custom-blink">
                カートの有効期限が切れています。再ログイン後、再度カートに追加をお願いします。
              </p>
            </div>
            <q-scroll-area visible style="height: 100%">
              <OrderCard
                v-for="(item, index) in order"
                :key="index"
                :num="index"
                :quote-flg="false"
                :data="item"
                @input-comment="inputDetailComment(item)"
                @delete="deleteConfirm(TYPE.ORDER, index, item.cart_result_detail_atto_id)"
              />
              <div v-if="order.length === 0" class="flex justify-center product-none">
                <p class="q-mb-none">注文商品がありません。</p>
              </div>
              <div v-if="order.length !== 0 && poType !== 'PO_RE_ARIBA' && cartLimitFlg === false">
                <p class="q-mb-none">※追加された商品の有効期限は上記日時です。</p>
                <p v-if="poType === 'PO_ARIBA' && cartLimitFlg === false" class="q-mb-none">
                  有効期限内にチェックアウトを行わなかった場合、商品が自動的に削除されますのでご注意ください。
                </p>
                <p v-else-if="cartLimitFlg === false" class="q-mb-none">
                  有効期限内に注文・問合せを行わなかった場合、商品が自動的に削除されますのでご注意ください。
                </p>
              </div>
            </q-scroll-area>
          </q-tab-panel>
          <q-tab-panel :name="TYPE.QUOTE">
            <div
              v-if="
                quotable.length !== 0 &&
                (poType === 'PO_NORMAL' || poType === 'PO_ARIBA') &&
                cartLimit.length > 0
              "
            >
              <p class="q-mb-none">カートの有効期限は {{ cartLimit }}になります。</p>
            </div>
            <div
              v-if="
                quotable.length !== 0 &&
                (poType === 'PO_NORMAL' || poType === 'PO_ARIBA') &&
                cartLimitFlg === true
              "
            >
              <p class="custom-blink">
                カートの有効期限が切れています。再ログイン後、再度カートに追加をお願いします。
              </p>
            </div>
            <q-scroll-area visible style="height: 100%">
              <OrderCard
                v-for="(item, index) in quotable"
                :key="index"
                :num="index"
                :quote-flg="true"
                :data="item"
                @input-comment="inputDetailComment(item)"
                @delete="deleteConfirm(TYPE.QUOTE, index, item.cart_result_detail_atto_id)"
              />
              <div v-if="quotable.length === 0" class="flex justify-center product-none">
                <p class="q-mb-none">問い合わせ商品がありません。</p>
              </div>
              <div v-if="quotable.length !== 0 && cartLimitFlg === false && cartLimitFlg === false">
                <p class="q-mb-none">※追加された商品の有効期限は上記日時です。</p>
                <p class="q-mb-none">
                  有効期限内に注文・問合せを行わなかった場合、商品が自動的に削除されますのでご注意ください。
                </p>
              </div>
            </q-scroll-area>
          </q-tab-panel>
        </q-tab-panels>
        <div class="order-area q-gutter-y-sm">
          <div class="row items-end">
            <label class="q-mb-sm" style="font-size: 1.1rem; font-weight: 600">コメント</label>
            <p class="notice-message q-mb-xs">
              ※その他ご要望がございましたら、こちらにご記入ください。<br />
            </p>
          </div>
          <div class="col">
            <q-input
              v-model="comment"
              outlined
              dense
              type="textarea"
              class="input-area"
              rows="3"
              maxlength="750"
              counter
              :disable="
                (tab === TYPE.ORDER && order.length === 0) ||
                (tab === TYPE.QUOTE && quotable.length === 0) ||
                (tab === TYPE.ORDER && poType === 'PO_RE_ARIBA') ||
                cartLimitFlg === true
              "
              @blur="updateComment"
            />
            <p class="example-message q-mb-none">
              例）納期が短いものを優先 / 予算は10万円以内 / SDS,CoAを添付 / 正式発注は購買部
            </p>
          </div>
          <div v-if="tab === TYPE.QUOTE">
            <q-radio
              v-model="quoteType"
              val="ONLY_STOCK"
              label="在庫品のみでのお見積り"
              color="primary"
              :disable="quotable.length === 0"
              @update:model-value="
                (value: string) => {
                  updateRequestRange(value);
                }
              "
            />
            <q-radio
              v-model="quoteType"
              val="STOCK_OR_SYNTHESIS"
              label="在庫品がない場合は、合成品も含めてお見積り"
              color="primary"
              :disable="quotable.length === 0"
              @update:model-value="
                (value: string) => {
                  updateRequestRange(value);
                }
              "
            />
          </div>
          <div
            class="q-gutter-y-xs q-mb-lg q-mt-lg"
            :style="'border-top: 1px solid rgba(0,0,0,.6); ' + tab === TYPE.ORDER ? '' : ''"
          >
            <div class="q-mb-lg flex items-end justify-between">
              <label>合計</label>
              <p class="q-mb-none">
                <span
                  class="text-weight-bolder"
                  style="font-size: 1.4rem; line-height: 1.4rem; margin-bottom: 0"
                >
                  {{ tab === TYPE.ORDER ? order.length : quotable.length }}
                </span>
                品目
              </p>
            </div>
            <div v-if="tab === TYPE.ORDER">
              <div class="flex items-end justify-between">
                <label>金額合計（税込）</label>
                <p class="q-mb-none">
                  <span
                    class="text-weight-bolder"
                    style="
                      font-size: 1.4rem;
                      line-height: 1.4rem;
                      margin-bottom: 0;
                      letter-spacing: 1px;
                    "
                  >
                    ￥ {{ commaFormat(totalAmount) }}
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div class="col-7 text-right q-gutter-x-xs">
            <q-btn
              v-if="tab === TYPE.ORDER && poType === 'PO_NORMAL'"
              color="primary"
              outline
              icon="mdi-download"
              label="お見積書発行"
              :disable="order.length === 0 || cartLimitFlg === true"
              @click="displayOutPdfDialog"
            ></q-btn>
            <q-btn
              v-if="tab === TYPE.ORDER && poType === 'PO_NORMAL'"
              icon="mdi-cart"
              label="注文"
              style="min-width: 160px; background: var(--q-primary)"
              text-color="white"
              :disable="order.length === 0 || isUserNotOrder === '1' || cartLimitFlg === true"
              @click="displayOrderConfDialog"
            />
            <q-btn
              v-if="tab === TYPE.ORDER && poType !== 'PO_NORMAL'"
              icon="mdi-cart"
              label="チェックアウト"
              style="min-width: 160px; background: var(--q-primary)"
              text-color="white"
              :disable="
                order.length === 0 ||
                isUserNotOrder === '1' ||
                poType === 'PO_RE_ARIBA' ||
                cartLimitFlg === true
              "
              @click="CheckOutConfDialog"
            />
            <q-btn
              v-if="tab === TYPE.QUOTE"
              icon="mdi-information-outline"
              text-color="white"
              label="お問い合わせ"
              style="min-width: 160px; background: var(--q-inquiry)"
              :disable="quotable.length === 0 || cartLimitFlg === true"
              @click="dispalyContactConfDialog"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- すべて削除確認ダイアログ -->
    <AlertDialog
      :display="allDeleteConfirmDialogFlg"
      level="information"
      title="削除確認"
      :text="dialogText"
      @confirm="allDelete"
      @close="allDeleteConfirmDialogFlg = false"
    />
    <!-- 削除確認ダイアログ -->
    <AlertDialog
      :display="deleteConfirmDialogFlg"
      level="information"
      title="削除確認"
      :text="['削除します。', 'よろしいですか？']"
      @confirm="individualDelete"
      @close="deleteConfirmDialogFlg = false"
    />
    <!-- 完了ダイアログ -->
    <AlertDialog
      :display="successDialogFlg"
      level="information"
      :title="dialogTittle"
      :text="dialogText"
      confirmation
      @complete="allDeleteSuccess"
    />
    <!-- 注文確認ダイアログ -->
    <OrderConfirmDialog
      :display="orderConfirmDialogFlg"
      @ok="orderRequest"
      @cancel="orderConfirmDialogFlg = false"
    />
    <!-- チェックアウト確認ダイアログ -->
    <CheckOutConfirmDialog
      :display="checkoutConfirmDialogFlg"
      @ok="checkoutRequest"
      @cancel="checkoutConfirmDialogFlg = false"
    />
    <!-- 問い合わせ確認ダイアログ -->
    <QuotationConfirmDialog
      :display="quotationConfirmDialogFlg"
      @ok="contactRequest"
      @cancel="quotationConfirmDialogFlg = false"
    />
    <!-- 注文完了ダイアログ -->
    <OrderSuccessDialog
      :display="orderSuccessDialogFlg"
      :order-no="orderNo"
      :btn-name="dialogBtnName"
      @ok="orderSuccessOk"
    />
    <!-- チェックアウト完了ダイアログ -->
    <ChekOutSuccessDialog
      :display="checkoutSuccessDialogFlg"
      :order-no="orderNo"
      :btn-name="dialogBtnName"
      @ok="chekoutSuccessOk"
    />
    <!-- 問い合わせ完了ダイアログ -->
    <QuotationSuccessDialog
      :display="quotationSuccessDialogFlg"
      :quotation-no="quotationNo"
      :btn-name="dialogBtnName"
      @ok="contactSuccessOk"
    />
    <!-- Excel出力ダイアログ -->
    <AlertDialog
      :display="isOutExcelDialog"
      :level="dialogLevel"
      :confirmation="isConfFlg"
      :title="dialogTittle"
      :text="dialogText"
      @complete="isOutExcelDialog = false"
      @confirm="downloadExcel"
      @close="isOutExcelDialog = false"
    />
    <!-- SDF出力ダイアログ -->
    <AlertDialog
      :display="isOutSdfDialog"
      :level="dialogLevel"
      :confirmation="isConfFlg"
      :title="dialogTittle"
      :text="dialogText"
      @complete="isOutSdfDialog = false"
      @confirm="downloadSdf"
      @close="isOutSdfDialog = false"
    />
    <!-- お見積書発行ダイアログ -->
    <AlertDialog
      :display="isOutPdfDialog"
      :level="dialogLevel"
      :confirmation="isConfFlg"
      :title="dialogTittle"
      :text="dialogText"
      @complete="isOutPdfDialog = false"
      @confirm="quotationRequest"
      @close="isOutPdfDialog = false"
    />
    <!-- エラーダイアログ -->
    <AlertDialog
      :display="errDialogFlg"
      level="error"
      :title="dialogTittle"
      :text="dialogText"
      @complete="errDialogFlg = false"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, inject, provide, readonly } from 'vue';
import { useRouter } from 'vue-router';
import { Loading } from 'quasar';
import { storeToRefs } from 'pinia';
import saveAs from 'file-saver';
import BatchInputBtn from '../components/button/BatchInputButton.vue';
import OrderCard from '../components/card/OrderCard.vue';
import PageHeaderBanner from '../components/banner/PageHeaderBanner.vue';
import AlertDialog from '../components/dialogs/AlertDialog.vue';
import OrderConfirmDialog from '../components/dialogs/OrderConfirmDialog.vue';
import CheckOutConfirmDialog from '../components/dialogs/CheckOutConfirmDialog.vue';
import OrderSuccessDialog from '../components/dialogs/OrderSuccessDialog.vue';
import ChekOutSuccessDialog from '../components/dialogs/ChekOutSuccessDialog.vue';
import QuotationConfirmDialog from '../components/dialogs/QuotationConfirmDialog.vue';
import QuotationSuccessDialog from '../components/dialogs/QuotationSuccessDialog.vue';
import http from '../common/axios-common';
import ResultStatusCode from '../common/code/ResultStatusCode';
import HttpResponseStatusCode from '../common/code/HttpResponseStatusCode';
import DetailResultStatusCode from '../common/code/DetailResultStatusCode';
import * as RegGroupCode from '../common/code/RegGroupCode';
import commaFormat from '../common/utils/numberUtils';
import base64toBlob from '../common/utils/fileUtils';
import countOrderQuotableKey from '../common/order-quotable-key';
import loginUserStore from '../store/loginUserStore';

const router = useRouter();

// データ interface
interface Data {
  cart_result_detail_atto_id: string;
  atto_id: string;
  structure_svg: string;
  cas: string;
  reg_group_code: string;
  reg_group_name: string;
  prtr_name: string;
  ishl_name: string;
  supplier_name: string;
  id_number: string;
  name1: string;
  capacity: string;
  packing: string;
  purity: string;
  selling_price: string;
  standard_delivery_time_name: string;
  desired_capacity: string | null;
  desired_quantity: string | null;
  comment: string;
}

// コメント一括入力 interface
interface AllInputComent {
  desiredCapacity: string | null;
  desiredQuantity: string | null;
  comment: string;
}

// 注文/問い合わせ種類
const TYPE = {
  ORDER: 'ORDER',
  QUOTE: 'QUOTE',
};

// 毒物
const POISON = '2';

// 注文/問い合わせタブ（order:注文, ）
const tab = ref<string>(TYPE.ORDER);

// 見積り種類
const quoteType = ref<string>('ONLY_STOCK');

// コメント
const comment = ref<string>('');

// 注文
const order = ref<Array<Data>>([]);

// 問い合わせ
const quotable = ref<Array<Data>>([]);

// 合計金額
const totalAmount = ref<number>(0);

// 税率
const taxRate = ref<number>(0);

// 注文番号
const orderNo = ref<string>('');

// 問い合わせ番号
const quotationNo = ref<string>('');

// 削除対象
const delType = ref<string>('');

// 削除要素
const delIndex = ref<number>(0);

// 削除カート詳細ID
const delCartResultDetailAttoId = ref<string>('');

// 問い合わせ完了ダイアログ表示フラグ
const quotationSuccessDialogFlg = ref<boolean>(false);

// 注文完了ダイアログ表示フラグ
const orderSuccessDialogFlg = ref<boolean>(false);

// チェックアウト完了ダイアログ表示フラグ
const checkoutSuccessDialogFlg = ref<boolean>(false);

// 完了ダイアログ表示フラグ
const successDialogFlg = ref<boolean>(false);

// 問い合わせ確認ダイアログ表示フラグ
const quotationConfirmDialogFlg = ref<boolean>(false);

// 注文確認ダイアログ表示フラグ
const orderConfirmDialogFlg = ref<boolean>(false);

// チェックアウト確認ダイアログ表示フラグ
const checkoutConfirmDialogFlg = ref<boolean>(false);

// すべて削除確認ダイアログ表示フラグ
const allDeleteConfirmDialogFlg = ref<boolean>(false);

// 削除確認ダイアログ表示フラグ
const deleteConfirmDialogFlg = ref<boolean>(false);

// エラーダイアログフラグ
const errDialogFlg = ref<boolean>(false);

// ダイアログボタン名
const dialogBtnName = ref<string>('');

// ダイアログテキスト
const dialogText = ref<Array<string>>(['']);

// ダイアログタイトル
const dialogTittle = ref<string>('');

// Dialog表示レベル
const dialogLevel = ref('');

// 確認Dialogフラグ
const isConfFlg = ref(false);

// Sdf出力確認Dialog表示フラグ
const isOutSdfDialog = ref(false);

// Excel出力確認Dialog表示フラグ
const isOutExcelDialog = ref(false);

// お見積書発行確認Dialog表示フラグ
const isOutPdfDialog = ref(false);

// 注文問い合わせ件数取得
const countOrderQuotable = inject(countOrderQuotableKey);

// 注文不可フラグ
const isNotOrder = ref(false);

// 問い合わせ不可フラグ
const isNotQuotable = ref(false);

// カート作成日時
const cartLimit = ref('');

// カート有効期限フラグ
const cartLimitFlg = ref(false);
provide('cartLimitFlg', readonly(cartLimitFlg));

// 注文不可ユーザフラグ
const isUserNotOrder = ref('');
// パンチアウト種別
const qutableFlg = ref(false);
// パンチアウト種別
const roleType = ref('');
const poType = ref('');
provide('roleType', readonly(roleType));
provide('poType', readonly(poType));

const orderLavel = ref<string>('注文');
/**
 * 合計金額
 */
const calcTotalAmount = () => {
  totalAmount.value = 0;
  if (order.value.length !== 0) {
    order.value.forEach((element) => {
      const amount = Number(element.selling_price) * Number(element.desired_quantity);
      totalAmount.value += amount + amount * taxRate.value;
    });
  }
};

/**
 * 法規制チェック
 */
const checkRegDialog = () => {
  isNotOrder.value = false;
  order.value.forEach((item) => {
    // 注文商品に取り扱い不可商品が存在する場合
    if (
      item.reg_group_code === '1' ||
      item.reg_group_code === '2' ||
      item.reg_group_code === '4' ||
      item.reg_group_code === '8'
    ) {
      isNotOrder.value = true;
    }
  });

  isNotQuotable.value = false;
  quotable.value.forEach((item) => {
    // 問合せ商品に取り扱い不可商品が存在する場合
    if (item.reg_group_code === '1' || item.reg_group_code === '4' || item.reg_group_code === '8') {
      isNotQuotable.value = true;
    }
  });

  // 注文商品に注文不可商品が存在する場合
  if (isNotOrder.value && tab.value === TYPE.ORDER) {
    dialogTittle.value = '取り扱い商品に変更がありました';
    dialogText.value = [
      '注文内容に取り扱いが中止になった商品が含まれています。',
      '取り扱いが中止になった商品を削除してください。',
      '毒物の商品につきましては、問い合わせのみご利用いただけます。',
      'ご不明な点がございましたら、お問い合わせください。',
    ];
    errDialogFlg.value = true;
  }
  // 問合せ商品に問合せ不可商品が存在する場合
  if (isNotQuotable.value && tab.value === TYPE.QUOTE) {
    dialogTittle.value = '取り扱い商品に変更がありました';
    dialogText.value = [
      '問い合わせ内容に取り扱いが中止になった商品が含まれています。',
      '取り扱いが中止になった商品を削除してください。',
      'ご不明な点がございましたら、お問い合わせください。',
    ];
    errDialogFlg.value = true;
  }
};

/**
 * カート情報取得
 */
const getCartInfo = async () => {
  await http
    .post('/csr001001/cart')
    .then((response) => {
      // エラーの場合
      if (response.data.common.status === ResultStatusCode.ERROR) {
        router.push({ name: 'error' });
      } else {
        order.value = response.data.orderCartItemList;
        quotable.value = response.data.quotableCartItemList;
        comment.value = response.data.cartInfo.general_comment;
        taxRate.value = response.data.taxRate;
        isNotOrder.value = response.data.isNotOrder;
        isUserNotOrder.value = response.data.isUserNotOrder;
        isNotQuotable.value = response.data.isNotQuotable;
        cartLimit.value = response.data.cartLimit;
        const limit = new Date(response.data.cartLimit);
        const now = new Date();
        if (poType.value !== 'PO_RE_ARIBA' && now.getTime() > limit.getTime()) {
          cartLimitFlg.value = true;
        }

        // 金額計算
        calcTotalAmount();
        if (order.value.length === 0 && quotable.value.length !== 0) {
          tab.value = TYPE.QUOTE;
        }
        if (order.value.length !== 0 && quotable.value.length === 0) {
          tab.value = TYPE.ORDER;
        }
        checkRegDialog();
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        //  エラー画面に遷移
        router.push({ name: 'error' });
      }
    });
};

// ログイン情報取得
const getLoginUser = () => {
  const loginUser = loginUserStore();
  const { role, po_type } = storeToRefs(loginUser);
  http
    .post('/ctp001001/loginUser')
    .then((response) => {
      // 異常終了の場合
      if (response.data.common.status === ResultStatusCode.ERROR) {
        router.push({ name: 'error' });
      } else {
        // ログインユーザー情報をstoreに設定
        loginUser.setLoginUser(response.data.loginUser);
        roleType.value = role.value;
        poType.value = po_type.value;
        // ユーザーID設定
        if (loginUser.po_type !== 'PO_NORMAL') {
          qutableFlg.value = true;
          orderLavel.value = 'チェックアウト';
        }
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    });
};
/**
 * 初期表示
 */
const init = async () => {
  // Loading Start
  Loading.show();
  try {
    getLoginUser();
    await getCartInfo();
  } finally {
    // Loading End
    Loading.hide();
  }
};

// 削除確認
const deleteConfirm = (modeType: string, index: number, cartResultDetailAttoId: string) => {
  delType.value = modeType;
  delIndex.value = index;
  delCartResultDetailAttoId.value = cartResultDetailAttoId;
  deleteConfirmDialogFlg.value = true;
};

// 削除
const individualDelete = () => {
  // Loading Start
  Loading.show();

  // 削除（フロントで保持しているデータ）
  if (delType.value === TYPE.ORDER) {
    order.value.splice(delIndex.value, 1);
  } else {
    quotable.value.splice(delIndex.value, 1);
  }

  const formData = new FormData();
  formData.append('cart_result_detail_atto_id', delCartResultDetailAttoId.value);

  http
    .post('/csr001001/delete', formData)
    .then((response) => {
      if (response.data.common.status === ResultStatusCode.ERROR) {
        router.push({ name: 'error' });
      } else {
        if (tab.value === TYPE.ORDER && order.value.length === 0 && quotable.value.length !== 0) {
          tab.value = TYPE.QUOTE;
          checkRegDialog();
        } else if (
          tab.value === TYPE.QUOTE &&
          order.value.length !== 0 &&
          quotable.value.length === 0
        ) {
          tab.value = TYPE.ORDER;
          quoteType.value = 'ONLY_STOCK';
          checkRegDialog();
        }
        if (order.value.length === 0 && quotable.value.length === 0) {
          comment.value = '';
          quoteType.value = 'ONLY_STOCK';
        }
        // 注文問い合わせ件数再取得
        countOrderQuotable?.();
        // 金額計算
        calcTotalAmount();
        deleteConfirmDialogFlg.value = false;
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        //  エラー画面に遷移
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * すべて削除確認のダイアログを表示
 */
const allDeleteConfirmDialog = () => {
  // ダイアログ表示
  allDeleteConfirmDialogFlg.value = true;
  // 削除確認ダイアログのtextを生成
  if (tab.value === TYPE.ORDER) {
    dialogText.value = ['注文内容をすべて削除します。', 'よろしいですか？'];
  } else {
    dialogText.value = ['問い合わせ内容をすべて削除します。', 'よろしいですか？'];
  }
};

/**
 * すべて削除
 */
const allDelete = () => {
  // Loading Start
  Loading.show();

  if (tab.value === TYPE.ORDER) {
    order.value = [];
  } else {
    quotable.value = [];
  }

  const formData = new FormData();
  formData.append('type', tab.value);

  http
    .post('/csr001001/allDelete', formData)
    .then((response) => {
      if (response.data.common.status === ResultStatusCode.ERROR) {
        router.push({ name: 'error' });
      } else {
        allDeleteConfirmDialogFlg.value = false;
        dialogTittle.value = '削除完了';
        // 削除確認ダイアログのtextを生成
        if (tab.value === TYPE.ORDER) {
          dialogText.value = ['注文内容をすべて削除しました。'];
        } else {
          dialogText.value = ['問い合わせ内容をすべて削除しました。'];
          quoteType.value = 'ONLY_STOCK';
        }
        successDialogFlg.value = true;
        if (order.value.length === 0 && quotable.value.length === 0) {
          comment.value = '';
          quoteType.value = 'ONLY_STOCK';
        }

        // 注文問い合わせ件数再取得
        countOrderQuotable?.();
        // 金額計算
        calcTotalAmount();
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        //  エラー画面に遷移
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * すべて削除完了
 */
const allDeleteSuccess = () => {
  successDialogFlg.value = false;
  if (tab.value === TYPE.ORDER && quotable.value.length !== 0 && order.value.length === 0) {
    tab.value = TYPE.QUOTE;
  }
  if (tab.value === TYPE.QUOTE && order.value.length !== 0 && quotable.value.length === 0) {
    tab.value = TYPE.ORDER;
  }
  // 法規制チェック
  checkRegDialog();
};

/**
 * 詳細コメント入力
 */
const inputDetailComment = (item: Data) => {
  // 数量入力エラーチェック
  if (
    item.desired_quantity === '' ||
    Number.isNaN(Number(item.desired_quantity)) ||
    Number(item.desired_quantity) < 1 ||
    Number(item.desired_quantity) > 99
  ) {
    dialogTittle.value = '数量入力エラー';
    dialogText.value = ['1～99の整数値を入力してください。'];
    errDialogFlg.value = true;
  }

  if (!errDialogFlg.value) {
    // コメント入力情報設定（フロントで保持しているデータ）
    if (tab.value === TYPE.ORDER) {
      order.value.forEach((element, index) => {
        if (element.cart_result_detail_atto_id === item.cart_result_detail_atto_id) {
          order.value[index] = item;
        }
      });
    } else {
      quotable.value.forEach((element, index) => {
        if (element.cart_result_detail_atto_id === item.cart_result_detail_atto_id) {
          quotable.value[index] = item;
        }
      });
    }

    const formData = new FormData();
    formData.append('cart_result_detail_atto_id', item.cart_result_detail_atto_id);
    if (item.comment !== null) {
      formData.append('comment', item.comment);
    } else {
      formData.append('comment', '');
    }
    if (item.desired_quantity !== null) {
      formData.append('desired_quantity', item.desired_quantity);
    } else {
      formData.append('desired_quantity', '');
    }
    if (item.desired_capacity !== null) {
      formData.append('desired_capacity', item.desired_capacity);
    } else {
      formData.append('desired_capacity', '');
    }

    http
      .post('/csr001001/updateDetailInput', formData)
      .then((response) => {
        if (response.data.common.status === ResultStatusCode.ERROR) {
          router.push({ name: 'error' });
        } else {
          // 金額計算
          calcTotalAmount();
        }
      })
      .catch((err) => {
        if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
          // セッションタイムアウトの場合
          router.push({ name: 'login', query: { timeout: 'timeout' } });
        } else {
          //  エラー画面に遷移
          router.push({ name: 'error' });
        }
      });
  }
};

/**
 * コメント、問い合わせ条件更新
 */
const updateComment = () => {
  const formData = new FormData();
  if (comment.value !== null) {
    formData.append('comment', comment.value);
  } else {
    formData.append('comment', '');
  }
  formData.append('request_range', quoteType.value);

  http
    .post('/csr001001/updateComment', formData)
    .then((response) => {
      if (response.data.common.status === ResultStatusCode.ERROR) {
        router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        //  エラー画面に遷移
        router.push({ name: 'error' });
      }
    });
};

/**
 * 問い合わせ条件変更
 */
const updateRequestRange = (value: string) => {
  quoteType.value = value;
  updateComment();
};

/**
 * 一括入力
 */
const allInput = (inputs: AllInputComent, modeType: string) => {
  // 数量入力チェック
  if (
    inputs.desiredQuantity === '' ||
    Number.isNaN(Number(inputs.desiredQuantity)) ||
    Number(inputs.desiredQuantity) < 1 ||
    Number(inputs.desiredQuantity) > 99
  ) {
    dialogTittle.value = '数量入力エラー';
    dialogText.value = ['1～99の整数値を入力してください。'];
    errDialogFlg.value = true;
  }

  // 希望容量入力チェック
  if (
    modeType === TYPE.QUOTE &&
    (inputs.desiredCapacity === null || inputs.desiredCapacity.trim() === '')
  ) {
    dialogTittle.value = '希望容量入力エラー';
    dialogText.value = ['希望容量を入力してください。'];
    errDialogFlg.value = true;
  }

  if (!errDialogFlg.value) {
    // Loading Start
    Loading.show();

    // 一括入力情報設定（フロントで保持しているデータ）
    const list: Array<Data> = [];
    if (modeType === TYPE.QUOTE) {
      quotable.value.forEach((item) => {
        const element = item;
        element.desired_quantity = inputs.desiredQuantity;
        element.comment = inputs.comment;
        element.desired_capacity = inputs.desiredCapacity;
        list.push(element);
      });
      quotable.value = list;
    } else {
      order.value.forEach((item) => {
        const element = item;
        element.desired_quantity = inputs.desiredQuantity;
        element.comment = inputs.comment;
        list.push(element);
      });
      order.value = list;
    }

    const formData = new FormData();
    if (inputs.comment !== null) {
      formData.append('comment', inputs.comment);
    } else {
      formData.append('comment', '');
    }
    if (inputs.desiredQuantity !== null) {
      formData.append('desired_quantity', inputs.desiredQuantity);
    } else {
      formData.append('desired_quantity', '');
    }
    if (inputs.desiredCapacity !== null) {
      formData.append('desired_capacity', inputs.desiredCapacity);
    } else {
      formData.append('desired_capacity', '');
    }
    formData.append('type', tab.value);

    http
      .post('/csr001001/updateAllInput', formData)
      .then((response) => {
        if (response.data.common.status === ResultStatusCode.ERROR) {
          router.push({ name: 'error' });
        } else {
          // 金額計算
          calcTotalAmount();
        }
      })
      .catch((err) => {
        if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
          // セッションタイムアウトの場合
          router.push({ name: 'login', query: { timeout: 'timeout' } });
        } else {
          //  エラー画面に遷移
          router.push({ name: 'error' });
        }
      })
      .finally(() => {
        // Loading End
        Loading.hide();
      });
  }
};

/**
 * Excel出力確認ダイアログ表示
 */
const displayOutExcelDialog = () => {
  dialogTittle.value = 'Excel出力確認';
  dialogLevel.value = 'information';
  dialogText.value = ['Excelファイルを出力します。', 'よろしいですか？'];
  isConfFlg.value = false;
  isOutExcelDialog.value = true;
};

/**
 * Excelダウンロード
 */
const downloadExcel = () => {
  // Loading Start
  Loading.show();

  isOutExcelDialog.value = false;

  const formData = new FormData();
  formData.append('requestType', tab.value);
  formData.append('fileType', 'XLSX');

  http
    .post('/csr001001/download', formData)
    .then((response) => {
      if (response.data.common.status === ResultStatusCode.ERROR) {
        router.push({ name: 'error' });
      } else {
        const blob = new Blob(
          [
            base64toBlob(
              response.data.file.file_data,
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            ),
          ],
          {}
        );
        saveAs(blob, response.data.file.file_name);
        // ダイアログ表示
        dialogTittle.value = 'Excel出力完了';
        dialogLevel.value = 'information';
        dialogText.value = ['Excelファイルを出力しました。'];
        isConfFlg.value = true;
        isOutSdfDialog.value = true;
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他のエラーの場合
        //  エラー画面に遷移
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * SDF出力確認ダイアログ表示
 */
const displayOutSdfDialog = () => {
  dialogTittle.value = 'SDFile出力確認';
  dialogLevel.value = 'information';
  dialogText.value = ['SDFileを出力します。', 'よろしいですか？'];
  isConfFlg.value = false;
  isOutSdfDialog.value = true;
};

/**
 * SDFダウンロード
 */
const downloadSdf = () => {
  // Loading Start
  Loading.show();

  isOutSdfDialog.value = false;

  const formData = new FormData();
  formData.append('requestType', tab.value);
  formData.append('fileType', 'SDF');

  http
    .post('/csr001001/download', formData)
    .then((response) => {
      if (response.data.common.status === ResultStatusCode.ERROR) {
        router.push({ name: 'error' });
      } else {
        const blob = new Blob([base64toBlob(response.data.file.file_data, 'text/plain')], {});
        saveAs(blob, response.data.file.file_name);
        // ダイアログ表示
        dialogTittle.value = 'SDFile出力完了';
        dialogLevel.value = 'information';
        dialogText.value = ['SDFileを出力しました。'];
        isConfFlg.value = true;
        isOutSdfDialog.value = true;
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他のエラーの場合
        //  エラー画面に遷移
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

const oderCheck = () => {
  // 数量入力チェック
  order.value.forEach((element) => {
    if (
      element.desired_quantity === '' ||
      Number.isNaN(Number(element.desired_quantity)) ||
      Number(element.desired_quantity) < 1 ||
      Number(element.desired_quantity) > 99
    ) {
      dialogTittle.value = '数量入力エラー';
      dialogText.value = ['1～99の整数値を入力してください。xxxx'];
      errDialogFlg.value = true;
    }
    // 法規制チェック
    if (
      RegGroupCode.getCodeList().indexOf(element.reg_group_code) !== -1 ||
      POISON === element.reg_group_code
    ) {
      dialogTittle.value = '取り扱い商品に変更がありました';
      dialogText.value = [
        '注文内容に取り扱いが中止になった商品が含まれています。',
        '取り扱いが中止になった商品を削除してください。',
        '毒物の商品につきましては、問い合わせのみご利用いただけます。',
        'ご不明な点がございましたら、お問い合わせください。',
      ];
      errDialogFlg.value = true;
    }
  });
};

/**
 * 注文確認ダイアログ表示
 */
const displayOrderConfDialog = () => {
  oderCheck();
  if (!errDialogFlg.value) {
    orderConfirmDialogFlg.value = true;
  }
};

/**
 * チェクアウト確認ダイアログ表示
 */
const CheckOutConfDialog = () => {
  oderCheck();
  if (!errDialogFlg.value) {
    checkoutConfirmDialogFlg.value = true;
  }
};

/**
 * 注文
 */
const orderRequest = () => {
  orderConfirmDialogFlg.value = false;
  oderCheck();
  if (!errDialogFlg.value) {
    // Loading Start
    Loading.show();

    const formData = new FormData();
    formData.append('type', 'ORDER');
    formData.append('punchOutProviderType', poType.value);

    http
      .post('/csr001001/request', formData)
      .then(async (response) => {
        if (response.data.common.status === ResultStatusCode.ERROR) {
          // 法規制チェック
          if (
            response.data.common.detail_status ===
            DetailResultStatusCode.PRODUCTS_NOT_AVAILABLE_ERROR
          ) {
            await getCartInfo();
          } else {
            router.push({ name: 'error' });
          }
        } else {
          orderNo.value = response.data.requestNo;
          order.value = response.data.orderCartItemList;
          quotable.value = response.data.quotableCartItemList;
          comment.value = response.data.cartInfo.general_comment;
          // 注文問い合わせ件数再取得
          countOrderQuotable?.();
          // 金額計算
          calcTotalAmount();
          if (order.value.length !== 0 || quotable.value.length !== 0) {
            dialogBtnName.value = '注文/問い合わせへ戻る';
          } else {
            dialogBtnName.value = 'TOPページへ戻る';
          }
          orderSuccessDialogFlg.value = true;
        }
      })
      .catch((err) => {
        if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
          // セッションタイムアウトの場合
          router.push({ name: 'login', query: { timeout: 'timeout' } });
        } else {
          //  エラー画面に遷移
          router.push({ name: 'error' });
        }
      })
      .finally(() => {
        // Loading End
        Loading.hide();
      });
  }
};

/**
 * チェックアウト
 */
const checkoutRequest = () => {
  checkoutConfirmDialogFlg.value = false;
  oderCheck();
  if (!errDialogFlg.value) {
    // Loading Start
    Loading.show();

    const formData = new FormData();
    formData.append('type', 'CHECKOUT');
    formData.append('punchOutProviderType', poType.value);

    http
      .post('/csr001001/request', formData)
      .then(async (response) => {
        if (response.data.common.status === ResultStatusCode.ERROR) {
          // 法規制チェック
          if (
            response.data.common.detail_status ===
            DetailResultStatusCode.PRODUCTS_NOT_AVAILABLE_ERROR
          ) {
            await getCartInfo();
          } else {
            router.push({ name: 'error' });
          }
        } else {
          orderNo.value = response.data.requestNo;
          order.value = response.data.orderCartItemList;
          quotable.value = response.data.quotableCartItemList;
          comment.value = response.data.cartInfo.general_comment;

          const form = document.createElement('form');
          form.action = response.data.browser_form_post;
          form.method = 'post';
          document.body.appendChild(form);

          const cxml = document.createElement('input');
          cxml.name = 'cxml-base64';
          cxml.value = response.data.punch_out_order_message_cxml;
          form.appendChild(cxml);
          form.submit();

          // 注文問い合わせ件数再取得
          countOrderQuotable?.();
          // 金額計算
          calcTotalAmount();
        }
      })
      .catch((err) => {
        if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
          // セッションタイムアウトの場合
          router.push({ name: 'login', query: { timeout: 'timeout' } });
        } else {
          //  エラー画面に遷移
          router.push({ name: 'error' });
        }
      })
      .finally(() => {
        // Loading End
        Loading.hide();
      });
  }
};
/**
 * お見積書発行確認ダイアログ表示
 */
const displayOutPdfDialog = () => {
  // 数量入力チェック
  order.value.forEach((element) => {
    if (
      element.desired_quantity === '' ||
      Number.isNaN(Number(element.desired_quantity)) ||
      Number(element.desired_quantity) < 1 ||
      Number(element.desired_quantity) > 99
    ) {
      dialogTittle.value = '数量入力エラー';
      dialogText.value = ['1～99の整数値を入力してください。'];
      errDialogFlg.value = true;
    }
    // 法規制チェック
    if (
      RegGroupCode.getCodeList().indexOf(element.reg_group_code) !== -1 ||
      POISON === element.reg_group_code
    ) {
      dialogTittle.value = '取り扱い商品に変更がありました';
      dialogText.value = [
        '注文内容に取り扱いが中止になった商品が含まれています。',
        '取り扱いが中止になった商品を削除してください。',
        '毒物の商品につきましては、問い合わせのみご利用いただけます。',
        'ご不明な点がございましたら、お問い合わせください。',
      ];
      errDialogFlg.value = true;
    }
  });

  if (!errDialogFlg.value) {
    dialogTittle.value = 'お見積書発行確認';
    dialogLevel.value = 'information';
    dialogText.value = [
      'お見積書を発行します。よろしいですか？',
      '',
      '※注文内容は保持されます。',
      '※法規制化学物質チェックを行うので処理に時間がかかる可能性があります。',
    ];
    isConfFlg.value = false;
    isOutPdfDialog.value = true;
  }
};

/**
 * お見積書発行
 */
const quotationRequest = () => {
  isOutPdfDialog.value = false;

  // 数量入力チェック
  order.value.forEach((element) => {
    if (
      element.desired_quantity === '' ||
      Number.isNaN(Number(element.desired_quantity)) ||
      Number(element.desired_quantity) < 1 ||
      Number(element.desired_quantity) > 99
    ) {
      dialogTittle.value = '数量入力エラー';
      dialogText.value = ['1～99の整数値を入力してください。'];
      errDialogFlg.value = true;
    }
    // 法規制チェック
    if (
      RegGroupCode.getCodeList().indexOf(element.reg_group_code) !== -1 ||
      POISON === element.reg_group_code
    ) {
      dialogTittle.value = '取り扱い商品に変更がありました';
      dialogText.value = [
        '注文内容に取り扱いが中止になった商品が含まれています。',
        '取り扱いが中止になった商品を削除してください。',
        '毒物の商品につきましては、問い合わせのみご利用いただけます。',
        'ご不明な点がございましたら、お問い合わせください。',
      ];
      errDialogFlg.value = true;
    }
  });

  if (!errDialogFlg.value) {
    // Loading Start
    Loading.show();

    const formData = new FormData();
    formData.append('type', 'QUOTATION');

    http
      .post('/csr001001/request', formData)
      .then(async (response) => {
        if (response.data.common.status === ResultStatusCode.ERROR) {
          // 法規制チェック
          if (
            response.data.common.detail_status ===
            DetailResultStatusCode.PRODUCTS_NOT_AVAILABLE_ERROR
          ) {
            await getCartInfo();
          } else {
            router.push({ name: 'error' });
          }
        } else {
          const blob = new Blob(
            [base64toBlob(response.data.file.file_data, 'application/pdf;charset=utf-8')],
            {}
          );
          saveAs(blob, response.data.file.file_name);
          // ダイアログ表示
          dialogTittle.value = 'お見積書発行完了';
          dialogLevel.value = 'information';
          dialogText.value = ['お見積書を発行しました。'];
          isConfFlg.value = true;
          isOutPdfDialog.value = true;
        }
      })
      .catch((err) => {
        if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
          // セッションタイムアウトの場合
          router.push({ name: 'login', query: { timeout: 'timeout' } });
        } else {
          //  エラー画面に遷移
          router.push({ name: 'error' });
        }
      })
      .finally(() => {
        // Loading End
        Loading.hide();
      });
  }
};

/**
 * お問合せ確認ダイアログ表示
 */
const dispalyContactConfDialog = () => {
  quotable.value.forEach((element) => {
    // 数量入力チェック
    if (
      element.desired_quantity === '' ||
      Number.isNaN(Number(element.desired_quantity)) ||
      Number(element.desired_quantity) < 1 ||
      Number(element.desired_quantity) > 99
    ) {
      dialogTittle.value = '数量入力エラー';
      dialogText.value = ['1～99の整数値を入力してください。'];
      errDialogFlg.value = true;
    }

    // 希望容量入力チェック
    if (element.desired_capacity === null || element.desired_capacity.trim() === '') {
      dialogTittle.value = '希望容量入力エラー';
      dialogText.value = ['希望容量を入力してください。'];
      errDialogFlg.value = true;
    }

    // 法規制チェック
    if (RegGroupCode.getCodeList().indexOf(element.reg_group_code) !== -1) {
      dialogTittle.value = '取り扱い商品に変更がありました';
      dialogText.value = [
        '問い合わせ内容に取り扱いが中止になった商品が含まれています。',
        '毒物の商品につきましては、問い合わせのみご利用いただけます。',
        'ご不明な点がございましたら、お問い合わせください。',
      ];
      errDialogFlg.value = true;
    }
  });
  if (!errDialogFlg.value) {
    quotationConfirmDialogFlg.value = true;
  }
};

/**
 * お問い合わせ
 */
const contactRequest = () => {
  quotationConfirmDialogFlg.value = false;

  quotable.value.forEach((element) => {
    // 数量入力チェック
    if (
      element.desired_quantity === '' ||
      Number.isNaN(Number(element.desired_quantity)) ||
      Number(element.desired_quantity) < 1 ||
      Number(element.desired_quantity) > 99
    ) {
      dialogTittle.value = '数量入力エラー';
      dialogText.value = ['1～99の整数値を入力してください。'];
      errDialogFlg.value = true;
    }

    // 希望容量入力チェック
    if (element.desired_capacity === null || element.desired_capacity.trim() === '') {
      dialogTittle.value = '希望容量入力エラー';
      dialogText.value = ['希望容量を入力してください。'];
      errDialogFlg.value = true;
    }
  });

  if (!errDialogFlg.value) {
    // Loading Start
    Loading.show();

    const formData = new FormData();
    formData.append('type', 'QUOTE');

    http
      .post('/csr001001/request', formData)
      .then(async (response) => {
        if (response.data.common.status === ResultStatusCode.ERROR) {
          // 法規制チェック
          if (
            response.data.common.detail_status ===
            DetailResultStatusCode.PRODUCTS_NOT_AVAILABLE_ERROR
          ) {
            await getCartInfo();
          } else {
            router.push({ name: 'error' });
          }
        } else {
          quotationNo.value = response.data.requestNo;
          order.value = response.data.orderCartItemList;
          quotable.value = response.data.quotableCartItemList;
          comment.value = response.data.cartInfo.general_comment;
          // 注文問い合わせ件数再取得
          countOrderQuotable?.();
          if (order.value.length !== 0 || quotable.value.length !== 0) {
            dialogBtnName.value = '注文/問い合わせへ戻る';
          } else {
            dialogBtnName.value = 'TOPページへ戻る';
          }
          quotationSuccessDialogFlg.value = true;
        }
      })
      .catch((err) => {
        if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
          // セッションタイムアウトの場合
          router.push({ name: 'login', query: { timeout: 'timeout' } });
        } else {
          //  エラー画面に遷移
          router.push({ name: 'error' });
        }
      })
      .finally(() => {
        // Loading End
        Loading.hide();
      });
  }
};

/**
 * 注文完了
 */
const orderSuccessOk = () => {
  if (quotable.value.length !== 0) {
    orderSuccessDialogFlg.value = false;
    tab.value = TYPE.QUOTE;
    // 法規制チェック
    checkRegDialog();
  } else {
    router.push({ name: 'top' });
  }
};

/**
 * チェックアウト完了
 */
const chekoutSuccessOk = () => {
  if (quotable.value.length !== 0) {
    checkoutSuccessDialogFlg.value = false;
    tab.value = TYPE.QUOTE;
    // 法規制チェック
    checkRegDialog();
  } else {
    router.push({ name: 'top' });
  }
};
/**
 * 問い合わせ完了
 */
const contactSuccessOk = () => {
  if (order.value.length !== 0) {
    quotationSuccessDialogFlg.value = false;
    tab.value = TYPE.ORDER;
    // 法規制チェック
    checkRegDialog();
  } else {
    router.push({ name: 'top' });
  }
};

// 初期処理
init();
</script>
<style scoped>
.csr00100-order-form {
  width: 100%;
  margin: 0 auto;
}
.csr00100-order-form .order-area {
  background-color: white;
  width: 420px;
  position: absolute;
  top: 8px;
  height: 100%;
  right: 15px;
  right: 0;
  padding-left: 10px;
  padding-right: 20px;
}

.csr00100-order-form .example-message {
  margin-left: 1rem;
  position: relative;
  margin-top: 6px;
}
.csr00100-order-form .notice-message {
  margin-left: 0.7rem;
  position: relative;
}
.csr00100-order-form .example-message:before {
  position: absolute;
  top: 0;
  left: -1.5rem;
}
.csr00100-order-form .notice-message:before {
  position: absolute;
  top: 0;
  left: -1.2rem;
}
.csr00100-order-form .q-tabs .tab-badge {
  top: 0;
  right: -28px;
  padding: 3px 8px;
  border-radius: 8px;
}
.csr00100-order-form .q-tab-panel {
  padding: 0;
}
.csr00100-order-form .q-tabs--dense .q-tab {
  padding: 5px 16px 0;
}

.csr00100-order-form .product-none {
  border: none;
  margin-top: 10px;
  background-color: #efefef;
  border-radius: 0px;
  padding: 80px 30px;
}

.csr00100-order-form .product-none p {
  letter-spacing: 3px;
  font-size: 1rem;
}
.q-btn:disabled {
  background-color: var(--q-opacityDisable) !important;
  border-color: var(--q-opacityDisable) !important;
  color: #fff !important;
}
</style>
<style>
.csr00100-order-form .q-card--bordered {
  border: 1px solid rgba(0, 0, 0, 0.6);
  margin-right: 12px;
}

.csr00100-order-form .q-card:last-child {
  margin-bottom: 0;
}

.csr00100-order-form .q-panel {
  padding-right: 440px;
  opacity: 1;
}

.csr00100-order-form .q-panel.q-transition--slide-left-leave-to,
.csr00100-order-form .q-panel.q-transition--slide-right-leave-to {
  opacity: 0;
  transition: opacity 2s ease-in-out;
}

.csr00100-order-form .order-area .q-field.q-textarea .q-field__control {
  min-height: 140px;
}

.csr00100-order-form .q-btn--outline:disabled:before {
  border: none;
}

.custom-blink {
  animation: blink-slow 1s infinite;
  color: #ff0000;
}

@keyframes blink-slow {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
